import { TRANSACTION_LIST, TRANSACTION_LIST_SUCCESS, TRANSACTION_LIST_FAILURE } from "../actionTypes";

export const getTransactionList = (payload) => ({
  type: TRANSACTION_LIST,
  payload,
});

export const getTransactionListSuccess = (payload) => ({
  type: TRANSACTION_LIST_SUCCESS,
  payload,
});

export const getTransactionListFailure = () => ({
  type: TRANSACTION_LIST_FAILURE,
});
